import PropTypes from 'prop-types'

import ReklaimModal, { ModalHeader, ModalBody, ModalTitle } from 'components/ReklaimModal'

import { STRING, SUPPORT_EMAIL } from 'resources'

import { ConfirmButton, Description, SupportLink } from './styles'

const RedeemSuccessModal = ({ isOpen, onRedeemSuccessClose }) => (
  <ReklaimModal isOpen={isOpen} centered>
    <ModalHeader toggle={onRedeemSuccessClose} />
    <ModalBody>
      <ModalTitle>{STRING.wallet.redemptions.giftCardRedemption.redeemSuccessTitle}</ModalTitle>
      <Description>{STRING.wallet.redemptions.giftCardRedemption.redeemSuccessDescription1}</Description>
      <Description>
        {STRING.wallet.redemptions.giftCardRedemption.redeemSuccessDescription2}
        <SupportLink href={`mailto:${SUPPORT_EMAIL}`} target="_blank" rel="noopener noreferrer">
          {SUPPORT_EMAIL}
        </SupportLink>
        {STRING.wallet.redemptions.giftCardRedemption.redeemSuccessDescription3}
      </Description>
      <ConfirmButton onPress={onRedeemSuccessClose}>
        {STRING.wallet.redemptions.giftCardRedemption.redeemSuccessConfirm}
      </ConfirmButton>
    </ModalBody>
  </ReklaimModal>
)

RedeemSuccessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRedeemSuccessClose: PropTypes.func.isRequired,
}

export default RedeemSuccessModal
